import React from 'react';

// The one green surface every public stats group sits on (#4598; founder
// 2026-10-17: "lets highlight anywhere we show stats in the green background
// like this one", pointing at the landing's "What the sources say" band).
// The landing trends band, the proof strip under Ask Astra, Planning's "The
// data behind the plan" and the papers' StatStrip all draw from here, so a
// stats group cannot drift into its own green.
//
// Contrast on the gradient's lighter end (#2D6B45): white 6.4:1, the tint
// #E3F0E2 5.4:1, both AA for body text. The tones the papers used to colour
// their numerals (amber, rose) fail on green, so numerals are white here.

/** The gradient and text colour, for a surface that cannot be a StatBand. */
export const STAT_BAND_SURFACE = 'bg-gradient-to-br from-[#1A4D2E] to-[#2D6B45] text-white';

/** One stat: a thin divider above it. */
export const STAT_ITEM = 'min-w-0 border-t border-white/20 pt-3';

/** A stat's numeral (size is the caller's). */
export const STAT_NUMERAL = 'font-serif font-bold leading-none lining-nums tabular-nums';

/** Body text and small print on the band. */
export const STAT_TINT = 'text-[#E3F0E2]';

/** A source link on the band: underlined, brighter on hover. */
export const STAT_LINK = 'underline underline-offset-2 decoration-white/30 hover:decoration-white';

const SHAPES = {
    // full-bleed, like the trends band: the caller sets its padding
    band: '',
    // inside a reading column (a paper), where a full-bleed band cannot reach
    panel: 'rounded-2xl',
};

/**
 * The green band. `as` is the element (a section by default), `shape` is
 * 'band' (full bleed) or 'panel' (rounded, inside a column), and every other
 * prop (id, data-*, aria-*) passes through.
 */
export default function StatBand({ as: Tag = 'section', shape = 'band', className = '', children, ...rest }) {
    return (
        <Tag data-stat-band={shape} className={`${STAT_BAND_SURFACE} ${SHAPES[shape] ?? ''} ${className}`.trim()} {...rest}>
            {children}
        </Tag>
    );
}
